import { format } from "date-fns";
import Highcharts from "highcharts";

function clearChartXAxis(index) {
  const $highchartAxaxisLabels = document.querySelectorAll(`g.highcharts-axis-labels.highcharts-xaxis-labels > text:nth-child(${index})`);

  if ($highchartAxaxisLabels && $highchartAxaxisLabels.length){
    $highchartAxaxisLabels.forEach(label => {
      label.innerHTML = '';
    });
  }
};

function checkDataLengthDiffernces(chartDataPrevious, chartDataCurrent) {
  if (chartDataPrevious.length > chartDataCurrent.length) {
    const diff = chartDataPrevious.length - chartDataCurrent.length;

    for (let i = 1; i  <= diff; i++) {
      clearChartXAxis(chartDataCurrent.length + i);
    }
  }
};

export function DrawChart(renderingDiv, chartDataPrevious, chartDataCurrent, previousBillingCycleDailyUsageData, currentBillingCycleDailyUsageData, xAxisLabels, chartXAxisSteps, lineColor) {
  Highcharts.chart(renderingDiv, {
    chart: {
      type: 'area',
      height: 400,
      marginLeft: 10,
      marginRight: 0,
      spacingLeft: 0,
      spacingRight: 0
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    title: {
      text: undefined
    },
    plotOptions: {
      series: {
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            halo: {
            size: 12,
            opacity: 0.5,
            attributes: {
                'stroke-width': 0,
                fill: lineColor,
                stroke: lineColor
              }
            }
          }
        }
      },
      area: {
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              enabled: true
            },
          }
        }
      }
    },
    series: [{
      name: 'Previous',
      data: chartDataPrevious,
      marker: {
        states: {
          hover: {
            enabled: false,
          }
        }
      }
    },
    {
      name: "Current",
      data: chartDataCurrent,
      color: lineColor,
      fill: 'none',
      lineWidth: 3,
      marker: {
        radius: 3,
        symbol: 'circle',
        lineColor: '#fff',
        lineWidth: 1,
      },
      shadow: {
        color: '#fff',
        width: 1,
        opacity: 1,
        offsetX: 0,
        offsetY: 0
    }
    }],
    xAxis: {
      lineWidth: 0,
      tickWidth: 0,
      tickInterval: 1,
      allowDecimals: false,
      categories: xAxisLabels,
      labels: {
        step: chartXAxisSteps,
        formatter: function () {
          return this.value;
        }
      }
    },
    yAxis: {
      title: {
        text: undefined
      },
      gridLineWidth: 1,
      className: 'usage-performance-y-axis-label',
      tickInterval: undefined,
      labels: {
        enabled: true,
        align: 'left',
        useHTML: true,
        formatter: function() {  
          let formattedValue = undefined;
          formattedValue = this.isLast ? `${this.value} kWh` : this.value ;
          return `<i class='value'>${formattedValue}</i>`;
        }
      },
    },
    tooltip: {
      shared: false,
      shadow: false,
      useHTML: true,
      outside: true,
      borderWidth: 0,
      borderRadius: 0,
      valueDecimals: 2,
      backgroundColor: "transparent",
      formatter: function (tooltip) {
        if (this.series.name === "Current") {
          const index = this.point.index;
          const dayNumber = index + 1;

          const prevIndex = previousBillingCycleDailyUsageData[index];
          const currentIndex = currentBillingCycleDailyUsageData[index];

          if (!currentIndex) {
            return '';
          }

          const currentDate = format(new Date(currentIndex.date), "MMM. dd, yyyy");

          let html = `
            <div class='my-account__usage-tooltip'>
              <div class='tooltip-rate gds-flex-container gds-flex-container--space-between'>
                <div class='gds-flex-container gds-flex-container--left'>
                  <div class='rate-swatch' style='background-color: ${lineColor}'></div>`
                    if (prevIndex) {
                      html += `<div class='rate-name'>${currentDate} - Day ${dayNumber}</div>`
                    } else {
                      html += `<div class="rate-name">${currentDate}</div>`;
                    }

                  html += `</div><div class="rate-value">${Math.floor(chartDataCurrent[index])}kWh</div>
                </div>
          `;

          if (prevIndex) {
            const prevDate = format(new Date(prevIndex.date), "MMM. dd, yyyy");

            html += `
              <div class='tooltip-rate gds-flex-container gds-flex-container--space-between'>
                <div class='gds-flex-container gds-flex-container--left'>
                  <div class='rate-swatch previous'></div>
                  <div class="rate-name">${prevDate} - Day ${dayNumber}</div>
                </div>
                <div class="rate-value">${Math.floor(chartDataPrevious[index])}kWh</div>
              </div>
            `
          }

          html += '</div>';

          return html;
        } else {
          return false;
        }
      }
    }
  });

  checkDataLengthDiffernces(chartDataPrevious, chartDataCurrent);
}

